var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcode"},[_c('div',{staticClass:"qrcode_content",attrs:{"id":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }